import { render, staticRenderFns } from "./OTActionsIndex.vue?vue&type=template&id=2efb060f&scoped=true&lang=pug"
import script from "./OTActionsIndex.vue?vue&type=script&lang=js"
export * from "./OTActionsIndex.vue?vue&type=script&lang=js"
import style0 from "./OTActionsIndex.vue?vue&type=style&index=0&id=2efb060f&prod&lang=scss&scoped=true"
import style1 from "./OTActionsIndex.vue?vue&type=style&index=1&id=2efb060f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efb060f",
  null
  
)

export default component.exports